import { IconCategory } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { ROOT_SLUG } from "../../../const/enviroment.ts";
import { EMPTY_CATEGORY } from "../../../const/typeDefault/Category.ts";
import { useCategory } from "../../../fetch/fetch.category.ts";
import { useActiveParams } from "../../../hooks/useActiveParams.ts";
import CategorySelectorContainer from "../container/CategorySelectorContainer.tsx";
import ParentCategoryList from "../list/ParentCategoryList.tsx";

const CATEGORY_ICON = <IconCategory />;

const BreadCrumbs = ({
  routeTo,
}: {
  routeTo: (parentId?: string) => string;
}) => {
  const { categorySlug } = useActiveParams();
  const { category } = useCategory(categorySlug, EMPTY_CATEGORY);
  return (
    <div className="breadcrumbs max-w-screen text-sm">
      <ul>
        <ParentCategoryList slug={categorySlug} showRoot>
          {(category) => (
            <li>
              <Link to={routeTo(category.slug)} className="truncate">
                {category.name}
              </Link>
            </li>
          )}
        </ParentCategoryList>
        <li>
          <Link to={routeTo(category.slug)}>{category.name}</Link>
        </li>
      </ul>
    </div>
  );
};
const ShopNavigation = ({
  routeTo,
}: {
  routeTo: (parentId?: string) => string;
}) => {
  const { categorySlug } = useActiveParams();
  return (
    <div className="flex flex-col">
      <div className="badge ml-4">
        <BreadCrumbs routeTo={routeTo} />
      </div>
      <div className="p-2">
        <CategorySelectorContainer routeTo={routeTo}>
          <div
            className={`${categorySlug !== ROOT_SLUG && "scale-0 opacity-0 h-0 hidden"} rounded-full glass-blurry p-4.75 scale-100`}
          >
            <h2 className={`flex gap-2 items-center `}>
              {CATEGORY_ICON}
              Wähle Kategorie
            </h2>
          </div>
        </CategorySelectorContainer>
      </div>
    </div>
  );
};
export default ShopNavigation;
